import React, { useEffect, useState } from "react";
import { get, post } from "../api";
import { errText, t } from "../i18n";
import { toast } from "../store";
import { Avatar, Button, Empty, Link, Spinner, useAsync } from "../ui";
import { subscribe } from "../api";

export function Friends() {
  const f = useAsync(() => get("/api/friends"));
  const [q, setQ] = useState("");
  const [results, setResults] = useState<any[]>([]);
  useEffect(() => subscribe((m) => { if (m.t === "presence") f.reload(); }) as any, []);
  useEffect(() => {
    if (q.trim().length < 2) return setResults([]);
    const id = setTimeout(() => get(`/api/users/search?q=${encodeURIComponent(q.trim())}`).then((r) => setResults(r.users), () => {}), 250);
    return () => clearTimeout(id);
  }, [q]);
  const act = async (fn: () => Promise<any>) => {
    try {
      await fn();
      f.reload();
    } catch (e) {
      toast(errText(e), "error");
    }
  };
  const row = (u: any, actions: React.ReactNode) => (
    <li key={u.id} className="list-row">
      <Avatar name={u.displayName ?? u.display_name} url={u.avatarUrl ?? u.avatar_url} online={u.online} size={40} />
      <Link to={`/u/${u.username}`} className="grow">{u.displayName ?? u.display_name} <small className="muted" dir="ltr">@{u.username}</small></Link>
      {actions}
    </li>
  );
  return (
    <div className="friends">
      <h1>{t.friends}</h1>
      <input className="search" placeholder={t.searchPlayers} value={q} onChange={(e) => setQ(e.target.value)} aria-label={t.searchPlayers} />
      {results.length > 0 && (
        <ul className="list panel">
          {results.map((u) => row(u, <Button kind="ghost" onClick={() => act(() => post("/api/friends/request", { userId: u.id }).then(() => toast(t.requestSent)))}>{t.addFriend}</Button>))}
        </ul>
      )}
      {f.loading && !f.data ? (
        <Spinner />
      ) : (
        <>
          {f.data?.incoming?.length > 0 && (
            <section className="panel">
              <h2>{t.incoming}</h2>
              <ul className="list">
                {f.data.incoming.map((u: any) =>
                  row(u, (
                    <span className="row">
                      <Button onClick={() => act(() => post("/api/friends/respond", { userId: u.id, accept: true }))}>{t.accept}</Button>
                      <Button kind="quiet" onClick={() => act(() => post("/api/friends/respond", { userId: u.id, accept: false }))}>{t.decline}</Button>
                    </span>
                  )),
                )}
              </ul>
            </section>
          )}
          <section className="panel">
            <h2>{t.friends}</h2>
            {f.data?.friends?.length ? (
              <ul className="list">
                {[...f.data.friends].sort((a: any, b: any) => Number(b.online) - Number(a.online)).map((u: any) => row(u, <small className="muted">{u.online ? t.online : t.offline}</small>))}
              </ul>
            ) : (
              <Empty>{t.noFriends}</Empty>
            )}
          </section>
          {f.data?.outgoing?.length > 0 && (
            <section className="panel">
              <h2>{t.outgoing}</h2>
              <ul className="list">{f.data.outgoing.map((u: any) => row(u, <small className="muted">{t.requestSent}</small>))}</ul>
            </section>
          )}
        </>
      )}
    </div>
  );
}
